import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_images, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_images_ai_description_translate } from '@/state/images/remote_images_ai_description_translate';
import { RequestImageAiDescriptionCreateOrTranslate } from '@shared/dto/+image/image_ai_description/_requests/request_image_ai_description_create_or_translate';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';

interface Props {
  grid2d: DTO__grid2d;
  entity: DTO__entity_with_grid2d;
}

export function WatcherImageToTextTranslate({ grid2d, entity }: Props) {
  const dispatch = use_dispatch();

  const { is_authorized } = use_slice_user(['is_authorized']);
  const { user_settings } = use_slice_user(['user_settings']);
  const { current_workspace_user, workspace_current } = use_slice_workspace(['current_workspace_user', 'workspace_current']);
  const { ai_descriptions_map, ai_descriptions_translation_in_progress } = use_slice_images(['ai_descriptions_map', 'ai_descriptions_translation_in_progress']);

  /*
   * EFFECTS
   */

  //set language from i18n

  use_effect(() => {
    if (!is_authorized) return; //not authorized
    if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.IMAGE_GET_AI_DESCRIPTION)) return; //not permitted to view
    if (grid2d.total_images_amount == 0) return; //no images to translate
    //todo:check is user guest

    void try_translate_texts();
  }, [user_settings.regional_language, is_authorized, grid2d.total_images_amount, entity, ai_descriptions_map, current_workspace_user, workspace_current._id]);

  /*
   * METHODS
   */

  async function try_translate_texts() {
    let cells_with_images = grid2d.cells__get_loaded().filter(cell => cell.image_id);

    if (cells_with_images.is_empty()) return;

    let requests = [];

    for (let cell of cells_with_images) {
      let ai_description_english = Array.from(ai_descriptions_map.values()).some(
        ai_description => ai_description.image_id == cell.image_id && ai_description.language == ENUM__language_type.ENGLISH,
      );

      let ai_description_native = Array.from(ai_descriptions_map.values()).some(
        ai_description => ai_description.image_id == cell.image_id && ai_description.language == user_settings.regional_language,
      );

      if (ai_descriptions_translation_in_progress.has(cell.image_id)) continue; //already in progress
      if (!ai_description_english) continue; //no english description
      if (ai_description_native) continue; //already translated

      let request = new RequestImageAiDescriptionCreateOrTranslate();
      request.image_id = cell.image_id;
      request.language = user_settings.regional_language;
      request.workspace_id = workspace_current._id;

      requests.push(request);
    }

    if (requests.length > 0) {
      await dispatch(remote_images_ai_description_translate(requests));
    }
  }

  return <></>;
}
